import { connect } from 'react-redux';
import { Instances } from '../../../constants';
import { IStateType } from '../../../store/models/root.interface';
import { makeSelectObjectsArray, requestObjects } from '../../../store/Objects';
import DictionarySelectField, {
	DispatchPropsType,
	MapStatePropsType,
	OwnPropsType
} from '../organisms/DictionarySelectFields';

const DictionarySelectFactory = (
	instanceId: Instances,
	valueToOption: Function
) => {
	const mapStateToProps = () => {
		const selectItems = makeSelectObjectsArray(instanceId);
		return (state: IStateType) => ({
			items: valueToOption(selectItems(state)),
		});
	};

	const mapDispatchToProps = {
		onLoad: () => requestObjects(instanceId),
	};

	return connect<
		MapStatePropsType,
		DispatchPropsType,
		OwnPropsType,
		IStateType
	>(
		mapStateToProps,
		mapDispatchToProps
	)(DictionarySelectField);
};

export default DictionarySelectFactory;
